import React, { useContext, useEffect, useState } from 'react'
import { newstore } from './OnlineOrdering/Home/Pages/Store/newStore';
import { Button, FloatingLabel, Form, Modal } from 'react-bootstrap';
import Notiflix from 'notiflix';
import { sha512 } from "js-sha512";
import PostApiCall from './Helpers/PostAPI';
import Cookies from "js-cookie";
import moment from 'moment';
import ForgotPassword from './ForgetPassword/ForgetPassword'
// import logo from "../";
import logo from "../assets/images/logo.png";

export const NewLoginModal = ({
	isOpen,
	handleToggleModal,
	modalSide = "Log",
	handleChangeModalSide,
}) => {
	const { setcart, setcartamount, setLoggedIn, clientData, setCartItems } = useContext(newstore)
	const [numRegex, setNumRegex] = useState(/^[0-9]*$/);
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);
	const [alphaNumericRegex, setAlphaNumericRegex] = useState(/^[a-zA-Z0-9]*$/);
	const [emailRegex, setEmailRegex] = useState(
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	);
	const [openForgotPass, setOpenForgotPass] = useState(false);
	const [enteredOtp, setEnteredOtp] = useState("");
	const [mailerOtp, setMailerOtp] = useState("");
	const [email, setEmail] = useState("");
	const [openOtp, setOpenOtp] = useState(false);
	const [openPassword, setOpenPassword] = useState(false);
	const [password, setPassword] = useState("");

	const [salt, setSalt] = useState([]);
	const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
	const [isConPasswordVisible, setIsConPasswordVisible] = useState(false);
	const [name, setName] = useState("");
	const [mobileNo, setMobileNo] = useState("");
	const [emailAddress, setEmailAddress] = useState(""); // when action is registration
	const [registerPassword, setRegisterPassword] = useState(""); // when action is registration
	const [confirmPassword, setConfirmPassword] = useState("");
	const [passwordFieldType, setPasswordFieldType] = useState(false);
	const [dobDay, setDobDay] = useState(1);
	const [dobMonth, setDobMonth] = useState("January");
	const [dobYear, setDobYear] = useState("2021");
	const [month, setMonth] = useState([]);
	const [day, setDay] = useState([]);
	const [year, setYear] = useState([]);
	const [gender, setGender] = useState("");
	const [guestLogin, setGuestLogin] = useState(false);
	const [genderData, setGenderData] = useState([
		{ label: "Male", value: "Male" },
		{ label: "Female", value: "Female" },
		{ label: "Others", value: "Others" },
	]);
	const [modalFace, setModalFace] = useState('Log');


	useEffect(() => {
		Notiflix.Loading.Init({
			svgColor: "#0f3d74",
		});

		var day = [];
		var monthdata = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December",
		];
		var month = [];
		var year = [];

		for (var i = 1; i <= 31; i++) {
			day.push({ label: i, value: i });
		}

		const date2 = new Date();

		for (var i = 0; i < Math.abs(date2.getUTCFullYear() - 1924); i++) {
			year.push({
				label: date2.getUTCFullYear() - i,
				value: date2.getUTCFullYear() - i,
			});
		}

		for (var i = 0; i < 12; i++) {
			month.push({ label: monthdata[i], value: monthdata[i] });
		}
		setMonth(month);
		setDay(day);
		setYear(year);
	}, []);

	// this will make sure the state is being updated from the props
	useEffect(() => {
		setModalFace(modalSide);
	}, [modalSide]);

	const handleSwitchGuestLogin = () => {
		setGuestLogin(!guestLogin)
	};

	const changeLogoutModal = () => {
		setOpenForgotPass(false);
	};

	const saveLogin = () => {
		if (email === "") {
			Notiflix.Notify.Failure("Please enter your email or mobile number.");
			return;
		} else if (!emailRegex.test(email) || numRegex.test(email)) {
			Notiflix.Notify.Failure("Please enter valid email or mobile number.");
			return;
		} else if (password === "") {
			Notiflix.Notify.Failure("Please enter your password.");
			return;
		}
		onLogin("login");
	};

	const onLogin = (type) => {
		Notiflix.Loading.Circle();
		PostApiCall.postRequest(
			{
				email: type == "register" ? emailAddress : email,
				password: type === "register" ? registerPassword : password,
				action: "Login",
				actiondate: moment().format("lll"),
			},
			"AddwebsiteLogin"
		).then((results) =>
			results.json().then((obj) => {
				if (
					(results.status == 200 || results.status == 201) &&
					localStorage.getItem("OrderData")
				) {
					localStorage.setItem("CustomerData", JSON.stringify(obj.data)); // set api user data to localstorage
					localStorage.setItem("access", JSON.stringify(obj.token)); // set the token data to access
					Notiflix.Loading.Remove();
					onPostMoveCart(obj);
					getCartdetails();
					setLoggedIn(true);
					handleToggleModal();
				} else if (results.status == 200 || results.status == 201) {
					Notiflix.Loading.Remove();
					localStorage.setItem("CustomerData", JSON.stringify(obj.data));
					localStorage.setItem("access", JSON.stringify(obj.token));
					if (localStorage.getItem("itemdetails")) {
						addToCart();
					}
					setLoggedIn(true);
					handleToggleModal();
					getCartdetails();
				} else {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Failure(obj.data?.originalError?.info?.message || obj?.data);
				}
			})
		);
	};

	const onPostMoveCart = (obj) => {
		var Order = localStorage.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);

		Notiflix.Loading.Circle();

		PostApiCall.postRequest(
			{
				customerid: JSON.stringify(obj.data[0]?.fld_customerid),
				cartid: Orderdetails[0]?.order_id,
			},
			"MoveTmpCrtToMain"
		).then((results) =>
			// const objs = JSON.parse(result._bodyText)
			results.json().then((obj) => {
				if (results.status == 200 || results.status == 201) {
					localStorage.removeItem("OrderData");
					Notiflix.Loading.Remove();
					if (localStorage.getItem("ReviewPage") == "ReviewPage") {
						// history.goBack();
					} else {
						window.location.href = "/";
					}
				} else {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Failure(obj.data);
				}
			})
		);
	};

	const addToCart = () => {
		var login = localStorage.getItem("CustomerData");
		var logindetails = JSON.parse(login);
		var Order = localStorage.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);
		var itemdetail = JSON.parse(localStorage.getItem("itemdetails"));
		PostApiCall.postRequest(
			{
				orderdate: moment().format("lll"),
				itemdetails: `
                 [
                 {
                     "Item":${itemdetail[0]?.Item
					},
                     "Quantity":${1}
                 }
                 ]
                 `,
				status: "INCART",
				customerid:
					localStorage.getItem("CustomerData") == null
						? null
						: logindetails[0].fld_customerid,
				createdon: moment().format("lll"),
				updatedon: moment().format("lll"),
				orderid:
					localStorage.getItem("OrderData") == null
						? 0
						: Orderdetails[0].order_id,
				updatedby:
					localStorage.getItem("CustomerData") == null
						? null
						: logindetails[0].fld_userid,
			},
			"AddToCartWebsite"
		).then((result) =>
			result.json().then((obj) => {
				if (result.status == 200 || result.status == 201) {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Success("Product added to Cart.");
					if (localStorage.getItem("OrderData") == null) {
						localStorage.setItem("OrderData", JSON.stringify(obj.data));
					}
					getCartdetails();
					localStorage.removeItem("itemdetails");
				} else {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Failure(obj.data);
				}
			})
		);
	};
	const getCartdetails = () => {
		Notiflix.Loading.Circle();
		var login = localStorage.getItem("CustomerData");
		var logindetails = JSON.parse(login);
		var Order = localStorage?.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);
		PostApiCall.postRequest(
			{
				orderid:
					localStorage.getItem("OrderData") == null
						? null
						: Orderdetails[0].order_id,
				id:
					localStorage.getItem("CustomerData") == null
						? null
						: logindetails[0].fld_customerid,
			},
			"GetCartWebsite"
		)
			.then((res) => res.json())
			.then((res1) => {
				if (res1.data) {
					Notiflix.Loading.Remove();
					setcart(res1?.data.reduce((a, v) => (a = a + v.fld_quantity), 0));
					setCartItems(res1.data);
				}
			});
	};

	const clearLoginForm = () => {
		setPassword("");
		setEmail("");
	};

	// ========RegistrationSave=========
	const onChangeGender = (gender) => {
		setGender(gender.target.value);
	};

	const clearGuestForm = () => {
		setName("");
		setEmailAddress("");
		setMobileNo("");
	};

	const validateGuestLogin = () => {
		if (name == "") {
			Notiflix.Notify.Failure("Please enter your name");
			return;
		}
		if (emailAddress == "") {
			Notiflix.Notify.Failure("Please enter your email");
			return;
		}
		if (mobileNo == "") {
			Notiflix.Notify.Failure("Please enter your mobile number");
			return;
		}
		onGuestLogin();
	};

	const onGuestLogin = () => {
		var Order = localStorage.getItem("OrderData");
		var Orderdetails = JSON.parse(Order);
		Notiflix.Loading.Circle();
		PostApiCall.postRequest(
			{
				name: name,
				email: emailAddress,
				mobile: mobileNo,
				cartid:
					localStorage?.getItem("OrderData") == null
						? null
						: Orderdetails[0].order_id,
				signupguest: "Continue",
			},
			"AddGuest"
		).then((result) =>
			result.json().then((obj) => {
				if (result.status == 200 || result.status == 201) {
					clearGuestForm();
					Notiflix.Notify.Success("Login Successfull");
					localStorage.setItem("CustomerData", JSON.stringify(obj.data));
					if (localStorage.getItem("itemdetails")) {
						addToCart();
					} else {
						getCartdetails();
					}
					Notiflix.Loading.Remove();
					setLoggedIn(true);
					handleToggleModal();
				} else {
					Notiflix.Loading.Remove();
					Notiflix.Notify.Failure(obj.data);
				}
			})
		);
	};

	const onPostRegistration = () => {
		Notiflix.Loading.Circle();

		PostApiCall.postRequest(
			{
				name: name,
				email: emailAddress,
				mobile: mobileNo,
				status: "Website",
				password: registerPassword,
				createdon: moment().format("lll"),
				updatedon: moment().format("lll"),
				updatedby: 0,
				dob: dobYear + "-" + dobMonth + "-" + dobDay,
				gender: gender,
			},
			"AddCustomer"
		).then((result) =>
			result.json().then((obj) => {
				if (result.status == 200 || result.status == 201) {
					onLogin("register");
				} else {
					Notiflix.Loading.Remove();
				}
			})
		);
	};
	const clearRegistrationForm = () => {
		setEmailAddress("");
		setMobileNo("");
		setRegisterPassword("");
		setName("");
		setGender("");
	};
	const SaveRegistration = () => {
		if (name === "") {
			Notiflix.Notify.Failure("Please enter your name");
			return;
		} else if (emailAddress === "") {
			Notiflix.Notify.Failure("Please enter your email");
			return;
		} else if (!emailRegex.test(emailAddress)) {
			Notiflix.Notify.Failure("Invalid email");
			return;
		} else if (mobileNo === "") {
			Notiflix.Notify.Failure("Please enter your mobile number");
			return;
		} else if (mobileNo.length !== 10) {
			Notiflix.Notify.Failure("Invalid mobile number");
			return;
		} else if (password === "") {
			Notiflix.Notify.Failure("Please enter your password");
			return;
		}
		onPostRegistration();
	};
	const ToggleForgotModal = (action) => {
		setModalFace(action);
		setOpenForgotPass(false);
	};

	return (
		<>
			<Modal show={isOpen}
				onHide={() => {
					setOpenForgotPass(false)
					handleToggleModal();
					setGuestLogin(false);
					clearGuestForm();
					clearLoginForm();
					clearRegistrationForm();
				}}>
				<Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
				<Modal.Body className="pt-0 login-guest-modal">
					<div className="d-flex justify-content-center align-items-center">
						<img src={clientData[0]?.fld_image || logo} className="img-fluid w-25 mb-4" alt="logo" />
					</div>
					{!openForgotPass &&
						<>

							<h2>Hello,</h2>
							<h3>Welcome!</h3>
						</>
					}
					{modalFace == "Log" && !guestLogin && !openForgotPass && (<div>
						<Form>
							<FloatingLabel
								controlId="floatingInput"
								label="User Name"
								className="mb-3"
							>
								<Form.Control
									type="email"
									placeholder="name@example.com"
									value={email}
									onChange={(email) => {
										setEmail(email.target.value);
									}}
								/>
							</FloatingLabel>
							<FloatingLabel
								controlId="floatingPassword"
								label="Password"
								className="mb-2"
							>
								<Form.Control
									type="password"
									placeholder="Password"
									value={password}
									onChange={(password) => {
										setPassword(password.target.value);
									}}
								/>
							</FloatingLabel>
							<p className="mb-3">
								<a
									href="javascript:void(0)"
									onClick={() => {
										setOpenForgotPass(true);
									}}
									className="text-capitalize menu-modal-category "
								>
									forgot password?
								</a>
							</p>
							<Button
								variant="danger"
								size="lg"
								className="w-100 mb-3 "
								onClick={(e) => {
									saveLogin();
								}}
							>
								Login
							</Button>
							<div className="align-items-center">
								<p className="mb-2 text-center">
									New User?{" "}
									<a
										href="javascript:void(0)"
										className="text-capitalize menu-modal-category "
										onClick={() => {
											setGuestLogin(false)
											handleChangeModalSide("Reg");
										}}
									>
										sign up
									</a>
								</p>
							</div>
							<span className="divider">
								<p>Or you can</p>
							</span>
							<Button
								variant="danger"
								size="lg"
								className="w-100 mb-3 "
								onClick={() => {
									handleSwitchGuestLogin();
								}}
							>
								Continue as Guest
							</Button>

							<div className="d-flex justify-content-between align-items-center">
								<p className="mb-2">
									{/* <a href="" className="text-capitalize text-danger">
										{loginError}
									</a> */}
								</p>
							</div>
						</Form>
					</div>)}
					{/* registration modal */}
					{modalFace == "Reg" && !guestLogin && !openForgotPass && (<div>
						<Form>
							<FloatingLabel
								controlId="floatingInput"
								label="User Name"
								className="mb-3"
							>
								<Form.Control
									type="email"
									placeholder="name@example.com"
									value={name}
									onChange={(name) => {
										setName(name.target.value);
									}}
								/>
							</FloatingLabel>
							<FloatingLabel
								controlId="floatingInput"
								label="Email ID"
								className="mb-3"
							>
								<Form.Control
									type="email"
									placeholder="name@example.com"
									value={emailAddress}
									onChange={(email) => {
										setEmailAddress(email.target.value);
									}}
								/>
							</FloatingLabel>
							<FloatingLabel
								controlId="floatingPassword"
								label="Mobile Number"
								className="mb-2"
							>
								<Form.Control
									type="text"
									placeholder="Mobile Number"
									value={mobileNo}
									onChange={(mobile) => {
										if (
											numRegex.test(mobile.target.value) &&
											mobile.target.value.length <= 10
										) {
											setMobileNo(mobile.target.value);
										}
									}}
								/>
							</FloatingLabel>
							<FloatingLabel
								controlId="floatingPassword"
								label="Password"
								className="mb-2"
							>
								<Form.Control
									type="password"
									placeholder="Password"
									value={password}
									onChange={(password) => {
										setPassword(password.target.value);
									}}
								/>
							</FloatingLabel>
							<p className="mb-3">
								<a
									href="javascript:void(0)"
									onClick={() => {
										setOpenForgotPass(true);
									}}
									className="text-capitalize menu-modal-category "
								>
									forgot password?
								</a>
							</p>
							<Button
								variant="danger"
								size="lg"
								className="w-100 mb-3 "
								onClick={() => {
									SaveRegistration()
								}}

							>
								Sign In
							</Button>
							<div className="align-items-center">
								<p className="mb-2 text-center">
									Already have an account?{" "}
									<a
										href="javascript:void(0)"
										className="text-capitalize menu-modal-category "
										onClick={() => {
											setGuestLogin(false)
											handleChangeModalSide("Log");
										}}
									>
										Login!
									</a>
								</p>
							</div>
							<span className="divider">
								<p>Or you can</p>
							</span>
							<Button
								variant="danger"
								size="lg"
								className="w-100 mb-3 "
								onClick={() => {
									handleSwitchGuestLogin();
								}}
							>
								Continue as Guest
							</Button>

							<div className="d-flex justify-content-between align-items-center">
								<p className="mb-2">
									{/* <a href="" className="text-capitalize text-danger">
										{loginError}
									</a> */}
								</p>
							</div>
						</Form>
					</div>)}

					{/* guest login */}
					{guestLogin && (<div>
						<Form>
							<FloatingLabel
								controlId="floatingInput"
								label="User Name"
								className="mb-3"
							>
								<Form.Control
									type="email"
									placeholder="name@example.com"
									value={name}
									onChange={(name) => {
										setName(name.target.value);
									}}
								/>
							</FloatingLabel>
							<FloatingLabel
								controlId="floatingInput"
								label="Email ID"
								className="mb-3"
							>
								<Form.Control
									type="email"
									placeholder="name@example.com"
									value={emailAddress}
									onChange={(email) => {
										setEmailAddress(email.target.value);
									}}
								/>
							</FloatingLabel>
							<FloatingLabel
								controlId="floatingPassword"
								label="Mobile Number"
								className="mb-2"
							>
								<Form.Control
									type="text"
									placeholder="Mobile Number"
									value={mobileNo}
									onChange={(mobile) => {
										if (
											numRegex.test(mobile.target.value) &&
											mobile.target.value.length <= 10
										) {
											setMobileNo(mobile.target.value);
										}
									}}
								/>
							</FloatingLabel>
							<Button
								variant="danger"
								size="lg"
								className="w-100 mb-3 "
								onClick={(e) => {
									validateGuestLogin();
								}}
							>
								Continue
							</Button>
							<div className="align-items-center">
								<p className="mb-2 text-center">
									Already have an account?{" "}
									<a
										href="javascript:void(0)"
										className="text-capitalize menu-modal-category "
										onClick={() => {
											setGuestLogin(false)
											handleChangeModalSide("Log");
										}}
									>
										Login!
									</a>
								</p>
							</div>
							<span className="divider">
								<p>Or you can</p>
							</span>
							<Button
								variant="danger"
								size="lg"
								className="w-100 mb-3 "
								onClick={() => {
									handleSwitchGuestLogin();
								}}
							>
								Continue as Guest
							</Button>

							<div className="d-flex justify-content-between align-items-center">
								<p className="mb-2">
									{/* <a href="" className="text-capitalize text-danger">
										{loginError}
									</a> */}
								</p>
							</div>
						</Form>
					</div>)}

					{openForgotPass &&
						<ForgotPassword ToggleForgotModal={ToggleForgotModal} />
					}
				</Modal.Body>
			</Modal>
		</>
	)
}
